import { render } from "./HomeNewsElement.vue?vue&type=template&id=6d295f20&scoped=true"
import script from "./HomeNewsElement.vue?vue&type=script&lang=js"
export * from "./HomeNewsElement.vue?vue&type=script&lang=js"

import "./HomeNewsElement.vue?vue&type=style&index=0&id=6d295f20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d295f20"]])

export default __exports__